import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=4045ae09&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045ae09",
  null
  
)

export default component.exports